import Pagination from './Pagination.component';

export default Pagination;
